'use client'

import Image from '@/ui/MediaImage'

import S from './ClubProfileHero.module.scss'

interface ClubProfileHeroProps {
  bannerUrl?: string
  bannerAlt: string
}

const DEFAULT_BANNER = '/assets/club-profile/club-profile-background.png'

const ClubProfileHero = ({ bannerUrl, bannerAlt }: ClubProfileHeroProps) => {
  return (
    <div className={S.hero}>
      <div className={S.imageWrapper}>
        <Image
          src={bannerUrl || DEFAULT_BANNER}
          alt={bannerAlt}
          fill
          priority
          className={S.image}
        />
      </div>
      <div className={S.gradient} />
    </div>
  )
}

export default ClubProfileHero
